export default "__VITE_ASSET__jCBsD9yU__"